import { createSlice } from '@reduxjs/toolkit';
import { catalogListProjectType } from './catalogAsyncThunk';

const catalogListProjectTypeSlice = createSlice({
  name: "catalog",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [catalogListProjectType.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [catalogListProjectType.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [catalogListProjectType.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default catalogListProjectTypeSlice.reducer;